export interface ConversationImpressionLog {
    conversationSids: string[];
    folders: string[];
    hasCompanyName: boolean[];
    hasTitleLink: boolean[];
    isArchived: boolean[];
    isInitiated: boolean[];
    isJobRemoved: boolean[];
    isOld: boolean[];
    lastEventId: string[];
    lastEventType: string[];
    positions: number[];
    reminders: boolean[];
    requireResponse: boolean[];
    types: string[];
    unreadCounts: number[];
    isPreApply: boolean[];
    jobKey: string[];
}

export interface JobDetailImpressionLog {
    conversationSids: string[];
    hasCompanyName: boolean[];
    hasCompanyPageURL: boolean[];
    hasJobSetting: boolean[];
    hasJobShift: boolean[];
    hasJobTitle: boolean[];
    hasJobType: boolean[];
    hasJobUrl: boolean[];
    hasLocation: boolean[];
    hasLogoUrl: boolean[];
    hasRating: boolean[];
    jobKey: string[];
}

export interface ReduxActionLog {
    actionType: string;
    // tslint:disable-next-line: no-any
    actionPayload: any;
}

export enum LogLevel {
    FATAL = 'fatal',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
    DEBUG = 'debug',
}

export enum PageEventType {
    INITIAL_BUNDLE_PING = 'initialBundlePing',
    INITIAL_CONVERSATIONS_FETCHED = 'initialConversationsFetched',
}
